import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
  VStack
} from "@chakra-ui/react";

import { ChevronDownIcon } from "@chakra-ui/icons";
import { useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import rarrow from "../../../img/rarrow.svg";
import { IUser } from "../../../models/auth.model";
import { ICalendarEvents } from "../../../models/calendar-model";
import coursesService from "../../../services/courses.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import userService from "../../../services/user.service";

const TrAttendanceList = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { course_id } = useParams();
  const toast = useToast();
  const [traineesList, setTrainees] = useState<any>();
  const [calendarevents, setCalendarEvents] = useState<ICalendarEvents[]>();
  const [user, setUser] = useState<IUser>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const courseName: null | string = localStorage.getItem("courseName");


  useEffect(() => {
    if (course_id) {
      coursesService
        .getAvailableCourses()
        .then((response) => {
          const available_course = response.find(
            (each) => each.course.uuid === course_id
          );

          if (available_course) {
            trainercoursesService
              .getAttendances(available_course.course.id)
              .then((res:any) => {
                const attendances = res;
                const updatedAttendances:any = [];

                const fetchUserProfiles = async () => {
                  for (const attendance of attendances) {
                    try {
                      const userProfile = await userService.getUserProfile(
                        attendance.user_id
                      );

                      attendance.userProfile = userProfile;
                      updatedAttendances.push(attendance);
                    } catch (error) {
                      console.error("Error fetching user profile:", error);
                    }
                  }

                  setTrainees(updatedAttendances);
                  console.log(updatedAttendances, "These are the updated attendances")
                };


                fetchUserProfiles();
                setLoading(false)
              })
              .catch((error) => {
                console.error("Error fetching attendances:", error);
              });
          }
        })
        .catch((error) => {
          console.error("Error fetching available courses:", error);
        });
    }
  }, [course_id]);


  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box width="100hw">
          <TrDashboardHeader />
          <Box bg="#F9F8F8" height="100%" width="100%" pt={"1.5rem"}>
            <Flex width="90%" mx="auto" pt="80px" pb="150px">
              <TrainerSidenav />
              <VStack width={{ lg: "80%", md: "75%", sm: "98%", base: "98%" }}>
                <HStack width={"100%"} height={"2rem"}>
                  <Text as="span" fontSize={"20px"}>
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={"20px"} color={"#616161"}>
                    My Trainee(s)
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={"20px"} color={"#616161"}>
                    Attendance
                  </Text>
                </HStack>
                <Box width={"100%"}>
                  <Box
                    width="100%"
                    mx="auto"
                    pb={{
                      lg: "200px",
                      md: "150px",
                      sm: "110px",
                      base: "110px",
                    }}
                    px={{
                      lg: "2.8rem",
                      md: "2.4rem",
                      sm: "2rem",
                      base: "1.4rem",
                    }}
                    pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                    bg="white"
                  >
                    <Flex
                      justifyContent={"space-between"}
                      flexDirection={{
                        lg: "row",
                        md: "column",
                        sm: "column",
                        base: "column",
                      }}
                    >
                      <Text
                        color="#1E1E1E"
                        fontSize="28px"
                        pb="30px"
                        fontWeight="600"
                      >
                        Attendance List{" "}
                      </Text>
                    </Flex>

                    <Flex
                      alignItems="center"
                      mb="40px"
                      justifyContent="space-between"
                      width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
                    >
                      <InputGroup
                        color="brand.subtitle"
                        bg="white"
                        mr="20px"
                        width="80%"
                      >
                        <Input
                          placeholder="Search trainees "
                          fontSize={12}
                          size="sm"
                        />
                        <InputRightElement
                          h="1.9rem"
                          pointerEvents="none"
                          children={<RiSearch2Line color="red" size="0.9rem" />}
                        />
                      </InputGroup>
                      {/* <Flex justifyContent="space-between"> */}
                      <Menu>
                        <MenuButton
                          as={Button}
                          rightIcon={<ChevronDownIcon />}
                          colorScheme="gray"
                          variant={"outline"}
                          size="sm"
                          fontSize={12}
                        >
                          Sort By
                        </MenuButton>
                        <MenuList fontSize={12}>
                          <MenuItem> Trainees</MenuItem>
                          <MenuItem>Assignment</MenuItem>
                        </MenuList>
                      </Menu>
                      {/* <Spacer mx={2} /> */}
                      {/* </Flex> */}
                    </Flex>
                    <TableContainer>
                      <Table variant="simple">
                        <Thead>
                          <Tr>
                            <Th> Trainee</Th>
                            <Th>Email</Th>
                            <Th> Trainee Code</Th>
                            {/* <Th>Attendance</Th> */}
                          </Tr>
                        </Thead>
                        <Tbody>
                          {traineesList &&
                            traineesList.map((each:any, index:number) => (
                              <Tr key={index}>
                                <Td>
                                  <HStack spacing={2}>
                                    <Avatar size={"sm"} name={each.userProfile.data.name} />
                                    <Text fontSize="14px" color="#616161">
                                      {each.userProfile.data.name}
                                    </Text>
                                  </HStack>
                                </Td>
                                <Td>
                                  <Text fontSize="14px" color="#616161">
                                    {each.userProfile.data.email}
                                  </Text>
                                </Td>
                                <Td>
                                  {" "}
                                  <Text fontSize="14px" color="#616161">
                                    {each.userProfile.data.code}
                                  </Text>
                                </Td>
                                {/* <Td>0</Td> */}
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              </VStack>
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TrAttendanceList;
